"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckMarkLoader = exports.CircleLoader = exports.CustomCheckboxText = exports.CustomCheckbox = exports.InlineImageWrapper = exports.EmailOtpTextWrapper = exports.OtpStatus = exports.ReadMoreCta = exports.PrivacySection = exports.PrivacyText = exports.ResendOtpButton = exports.Success = exports.ButtonText = exports.ButtonWrapper = exports.ErrorText = exports.Image = exports.StyledText = exports.ContentWrapper = exports.LoginWrapper = exports.SampleStyle = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const building_blocks_ui_typography_1 = require("@acko-tech/building-blocks.ui.typography");
const responsive_1 = require("./responsive");
exports.SampleStyle = building_blocks_ui_common_1.styled.div `
  width: 360px;
`;
exports.LoginWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  margin-top: 50px;
  postion: relative;
  justify-content: center;
  @media ${responsive_1.device.tablet} {
    margin-top: 30px;
  }
  ${(props) => props.padding && `padding: ${props.padding};`}
`;
exports.ContentWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  flex-direction: column;
  align-items: center;
  width: 320px;
`;
exports.StyledText = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: ${(props) => (props.fontSize ? props.fontSize : '18px')};
  color: ${(props) => (props.color ? props.color : '#151619')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '500')};
  ${(props) => props.margin && `margin: ${props.margin};`}
  ${(props) => props.textAlign && `text-align: ${props.textAlign};`}
    ${(props) => props.padding && `padding: ${props.padding};`}
`;
exports.Image = building_blocks_ui_common_1.styled.img `
  height: ${(props) => (props.height ? props.height : '150px')};
  width: ${(props) => (props.width ? props.width : '150px')};
`;
exports.ErrorText = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
    color: #db2c2c;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400
    ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`}
    text-align: center;
`;
// Button Styles
exports.ButtonWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  background: ${(props) => (props.isActive ? '#44cb86' : '#8d99a7')};
  justify-content: center;
  align-items: center;
  ${(props) => props.isActive && `cursor: pointer;`}
  ${(props) => !props.isActive && `cursor: not-allowed;`}
    width: ${(props) => (props.width ? props.width : '130px')};
  height: ${(props) => (props.height ? props.height : '50px')};
  border-radius: 8px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
`;
exports.ButtonText = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
    color: #ffffff;
    font-weight: 500;
    font-size: height: ${(props) => (props.fontSize ? props.fontSize : '16px')};
    line-height: 18px;
`;
exports.Success = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  color: #00a871;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin-top: 10px;
`;
exports.ResendOtpButton = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  margin-top: 40px;
  padding: 10px;
  width: fit-content;
  cursor: pointer;
  ${(props) => !props.isActive &&
    `
        cursor: not-allowed;
    `}
`;
exports.PrivacyText = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: 10px;
  position: absolute;
  line-height: 12px;
  color: #434f5a;
  @media (max-width: 360px) {
    padding-bottom: 20px;
  }
`;
exports.PrivacySection = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  position: absolute;
  justify-content: center;
  top: max(100vh - 40px, 700px);
  align-items: center;
`;
exports.ReadMoreCta = building_blocks_ui_common_1.styled.span `
  color: #0091dd;
  cursor: pointer;
  font-size: 10.5px;
`;
exports.OtpStatus = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: 14px;
  line-height: 16px;
  color: #434f5a;
  margin-left: 10px;
  @media ${responsive_1.device.tablet} {
    font-size: 12px;
    margin-left: 6px;
  }
`;
exports.EmailOtpTextWrapper = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  flex-direction: column;
  width: 100vw !important;
  padding: 0 30px;
  box-sizing: border-box;
  justify-content: center;
`;
exports.InlineImageWrapper = building_blocks_ui_common_1.styled.div `
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 5px;
`;
exports.CustomCheckbox = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  width: 15px;
  height: 15px;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  position: relative;
  box-sizing: content-box;
  border: 1px solid;
  ${(props) => props.checked
    ? `background: #44CB86; border-color: #44CB86;`
    : `border-color: #D6D9E0;`}
  ::after {
    content: '';
    width: 4.3px;
    height: 8.6px;
    border: 1px solid #ffffff;
    border-width: 0 2px 2px 0;
    border-radius: 1px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(40deg);
    position: absolute;
    top: 2px;
    right: 5px;
  }
`;
exports.CustomCheckboxText = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_typography_1.Text) `
  font-size: 14px;
  line-height: 20px;
  color: #282e33;
  margin-left: 10px;
`;
const LoaderSpin = (0, building_blocks_ui_common_1.keyframes) `
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const CheckMark = (0, building_blocks_ui_common_1.keyframes) `
  0% {
    height: 0;
    width: 0;
    opacity: 1;
  }
  20% {
    height: 0;
    width: $check-width;
    opacity: 1;
  }
  40% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
  100% {
    height: $check-height;
    width: $check-width;
    opacity: 1;
  }
`;
exports.CircleLoader = building_blocks_ui_common_1.styled.div `
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-left-color: #5cb85c;
  animation: ${LoaderSpin} 1.2s infinite linear;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  position: relative;
`;
exports.CheckMarkLoader = building_blocks_ui_common_1.styled.div `
  &:after {
    animation-duration: 800ms;
    animation-timing-function: ease;
    animation-name: ${CheckMark};
    transform: scaleX(-1) rotate(135deg);
  }

  &:after {
    opacity: 1;
    height: 12px;
    width: 12px;
    transform-origin: left top;
    border-right: 2px solid #5cb85c;
    border-top: 2px solid #5cb85c;
    content: '';
    left: 12px;
    top: 12px;
    position: relative;
  }
`;
//# sourceMappingURL=login.styles.js.map